import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "過剰", enum: "EXCESS" },
  { value: 2, text: "不足", enum: "DEFICIENCY" },
]);
